<template>
  <div>
    <div class="bd-header bd-header_m24">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/m24/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-m24">
      <div class="bd-m24__wrapper">
        <h1 class="bd-m24__title">Новости</h1>
        <div class="bd-m24-news">
          <h2 class="bd-m24-news__point">Сегодня</h2>

          <div
            v-for='item in pageData.news1'
            :key='item.title'>
            <div class="bd-m24-news__item">
              <div class="bd-m24-news__img-wrap">
                <img :src="item.img" alt="" class="bd-m24-news__img">
              </div>
              <div class="bd-m24-news__title">{{ item.title }}</div>
              <div class="bd-m24-news__date">{{ item.date }}</div>
              <ul class="bd-m24-news__category">
                <li class="bd-m24-news__category-name">{{ item.category }}</li>
                <li class="bd-m24-news__category-name">{{ item.category2 }}</li>
              </ul>
            </div>
          </div>
          <buzzCode @ready="ready" :id="id"></buzzCode>
        </div>

        <div class="bd-m24-news">
          <h2 class="bd-m24-news__point">Вчера</h2>
          <div
            v-for='item in pageData.news2'
            :key='item.title'>
            <div class="bd-m24-news__item">
              <div class="bd-m24-news__img-wrap">
                <img :src="item.img" alt="" class="bd-m24-news__img">
              </div>
              <div class="bd-m24-news__title">{{ item.title }}</div>
              <div class="bd-m24-news__date">{{ item.date }}</div>
              <ul class="bd-m24-news__category">
                <li class="bd-m24-news__category-name">{{ item.category }}</li>
                <li class="bd-m24-news__category-name">{{ item.category2 }}</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="bd-m24-footer">
          <div class="bd-m24-footer__top">© 2012 – 2017 M24.RU</div>
          <div class="bd-m24-footer__text">Все права на материалы,
            находящиеся на сайте m24.ru, охраняются в соответствии с
            законодательством РФ, в том числе об авторском праве и
            смежных правах. При любом использовании материалов сайта ссылка
            на m24.ru обязательна. Редакция не несет ответственности
            за информацию и мнения, высказанные в комментариях читателей
            и новостных материалах, составленных на основе
            сообщений читателей.</div>
          <div class="bd-m24-footer__text">СМИ сетевое издание «Городской
            информационный канал m24.ru» зарегистрировано в
            Федеральной службе по надзору в сфере связи, информационных
            технологий и массовых коммуникаций. Свидетельство о
            регистрации средства массовой информации Эл
            № ФС77-53981 от 30 апреля 2013 г.</div>
          <div class="bd-m24-footer__text">Средство массовой информации
            сетевое издание «Городской информационный канал m24.ru»
            создано при финансовой поддержке Департамента средств массовой
            информации и рекламы г. Москвы. (С) АО «Москва Медиа»</div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'm24',
  data() {
    return {
      pageData: {
        news1: [
          {
            date: '9:30',
            category: 'Транспорт',
            category2: 'Парковки',
            title: 'Парковки только для электромобилей появились в центре столицы',
            img: '/pages/m24/img/1.jpg',
          },
          {
            date: '9:10',
            category: 'Метро',
            category2: 'Благоустройство',
            title: 'Более 60 эскалаторов отремонтировали в московском метро за 2017 год',
            img: '/pages/m24/img/2.jpg',
          },
          {
            date: '8:40',
            category: 'Общество',
            category2: 'Проишествие',
            title: 'На МКАД столкнулись три грузовика',
            img: '/pages/m24/img/3.jpg',
          },
          {
            date: '8:35',
            category: 'Медицина',
            category2: 'Парки',
            title: 'В День города в парках Москвы заработают шатры здоровья',
            img: '/pages/m24/img/4.jpg',
          },
          {
            date: '8:00',
            category: 'Культура',
            category2: 'Искусство',
            title: 'Оксана Федорова возглавила Музей моды в столице',
            img: '/pages/m24/img/5.jpg',
          },
        ],
        news2: [
          {
            date: '3:12',
            category: 'За рубежом',
            category2: 'Проишествия',
            title: 'Скорость ветра в урагане "Ирма" достигла 220 км/ч',
            img: '/pages/m24/img/6.jpg',
          },
          {
            date: '2:58',
            category: 'Погода',
            category2: 'Город',
            title: 'Сильные дожди и ветер до 17 м/с ожидаются в Москве во вторник',
            img: '/pages/m24/img/7.jpg',
          },
          {
            date: '2:00',
            category: 'Метро',
            category2: 'Строительство',
            title: 'Метро-2021. Новое кольцо и станции далеко за МКАД',
            img: '/pages/m24/img/8.jpg',
          },
          {
            date: '1:40',
            category: 'Проишествия',
            category2: 'Политика',
            title: 'СМИ сообщили о ДТП с участием сына министра Силуанова',
            img: '/pages/m24/img/9.jpg',
          },
          {
            date: '1:21',
            category: 'За рубежом',
            category2: 'Политика',
            title: 'Трамп одобрил многомиллиардные поставки оружия Южной Корее',
            img: '/pages/m24/img/10.jpg',
          },
        ],
      },
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_m24
      background-color #fff
      & ^[1]__menu
        fill #282774
        height 25px
      .bd-ht
        &__img
          display block
          width 120px
          height auto
        &__search
          width 17px
          height 17px
          margin-right 14px
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-m24
    background-color white
    text-align left
    &__wrapper
      padding 25px 0 0 0
      margin 0 15px 30px 15px
    &__title
      margin 0 0 30px
      font-family Lato, sans-serif
      fontSize(38,38)
      font-weight 700
      color #251e23
    &-news
      font-family Lato, sans-serif
      &__point
        margin 0 0 20px
        fontSize(26,26)
        font-weight 700
        color #32292f
      &__item
        min-height 100px
        padding-bottom 30px
        clear both
        &:last-child
          padding-bottom 0
        &:nth-child(2n)
          & ^[2]__img-wrap
            background-color #fe7a6c
        &:nth-child(2n+1)
          & ^[2]__img-wrap
            background-color #4f4fb3
        &:nth-child(3n+2)
          & ^[2]__img-wrap
            background-color #ecc31e
      &__category
        list-style-type none
        margin 10px 0 0
        padding 0
        clear both
      &__category-name
        display inline-block
        margin 0 10px 10px 0
        padding 0 10px
        border-radius 4px
        background #f2fafd
        fontSize(12,20)
        color #282774
      &__img-wrap
        position relative
        float left
        width 120px
        height 78px
        margin 5px 10px 10px 5px
      &__img
        position relative
        left -5px
        top -5px
        width 100%
        height auto
      &__date
        display inline
        margin 0 0 0 10px
        opacity 0.5
        fontSize(10,10)
        letter-spacing 1px
        color #282774
      &__title
        display inline
        fontSize(15,20)
        color #32292f
    &-footer
      padding 40px 0
      font-family Rubik,sans-serif
      color #ede5d2
      &__logo
        width 70%
        margin 20px auto
        &-img
          display block
          width 100%
          height auto
      &__top
        margin 0 50px 10px 0
        fontSize(15,21)
        text-transform uppercase
        color #32292f
      &__text
        margin 0 0 15px 0
        fontSize(13,18)
        color #b3b3b3
</style>
